var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6016 8.50745C15.8782 9.37404 16.7727 10.5481 16.7727 12.1136V14.909H20.5V12.1136C20.5 10.0822 17.1734 8.88017 14.6016 8.50745Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45457 7.45455C9.51308 7.45455 11.1818 5.78579 11.1818 3.72727C11.1818 1.66876 9.51308 0 7.45457 0C5.39605 0 3.72729 1.66876 3.72729 3.72727C3.72729 5.78579 5.39605 7.45455 7.45457 7.45455Z",
    fill: "#868686"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0455 7.45455C15.1048 7.45455 16.7727 5.78659 16.7727 3.72727C16.7727 1.66795 15.1048 0 13.0455 0C12.6075 0 12.1975 0.0931816 11.8062 0.223636C12.5796 1.18341 13.0455 2.40409 13.0455 3.72727C13.0455 5.05045 12.5796 6.27114 11.8062 7.23091C12.1975 7.36136 12.6075 7.45455 13.0455 7.45455Z",
    fill: "#868686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45455 8.38635C4.96659 8.38635 0 9.63499 0 12.1136V14.9091H14.9091V12.1136C14.9091 9.63499 9.9425 8.38635 7.45455 8.38635Z",
    fill: "#868686"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.744ed36814d9a48a099241644e8ef562.svg";
export { ForwardRef as ReactComponent };